export default "__VITE_ASSET__b5246308__"